"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Url = /** @class */ (function () {
    function Url() {
    }
    Url.prototype.baseURL = function (url) {
        var noQueryParametersURl = url.split('?')[0] || '';
        var res = noQueryParametersURl.match(/^(?:https?:\/\/)?(?:[^@/\n]+@)?(?:www\.)?([^:/\n]+)(?:(:\d*)?)/g);
        if (res === null)
            return '';
        return res[0];
    };
    Url.prototype.getUrlParamsByName = function (uri, name) {
        var u = !/\w+:\/\//.test(uri) ? "http://".concat(uri) : uri;
        var params = new URL(u).searchParams;
        var queryParam = (params.get(name) || '').trim();
        if (queryParam.length === 0)
            return null;
        return queryParam;
    };
    return Url;
}());
exports.default = Url;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXJsLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInNyYy9saWIvdXRpbHMvdXJsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUE7SUFBQTtJQWlCQSxDQUFDO0lBaEJHLHFCQUFPLEdBQVAsVUFBUSxHQUFXO1FBQ2YsSUFBTSxvQkFBb0IsR0FBRyxHQUFHLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLEVBQUUsQ0FBQTtRQUNwRCxJQUFNLEdBQUcsR0FBRyxvQkFBb0IsQ0FBQyxLQUFLLENBQUMsaUVBQWlFLENBQUMsQ0FBQTtRQUN6RyxJQUFJLEdBQUcsS0FBSyxJQUFJO1lBQUUsT0FBTyxFQUFFLENBQUE7UUFFM0IsT0FBTyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUE7SUFDakIsQ0FBQztJQUVELGdDQUFrQixHQUFsQixVQUFtQixHQUFXLEVBQUUsSUFBWTtRQUN4QyxJQUFNLENBQUMsR0FBRyxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLGlCQUFVLEdBQUcsQ0FBRSxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUE7UUFDdkQsSUFBTSxNQUFNLEdBQUcsSUFBSSxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsWUFBWSxDQUFBO1FBQ3RDLElBQU0sVUFBVSxHQUFHLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFLENBQUMsQ0FBQyxJQUFJLEVBQUUsQ0FBQTtRQUVsRCxJQUFJLFVBQVUsQ0FBQyxNQUFNLEtBQUssQ0FBQztZQUFFLE9BQU8sSUFBSSxDQUFBO1FBQ3hDLE9BQU8sVUFBVSxDQUFBO0lBQ3JCLENBQUM7SUFDTCxVQUFDO0FBQUQsQ0FBQyxBQWpCRCxJQWlCQyJ9